import React, { useState, useEffect } from "react";
import SelectList from "../../Components/Select";
import { callAPI } from "../../utils/callAPI";
import axios from "axios";
import { apiEndPoints } from "../../constants/apiEndPoints";
import DatePickerField from "../../Components/DatePickerField";
import TextArea from "../../Components/TextArea";
import "../Pages.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TextInputField from "../../Components/TextInputField";

const initialProjectData = {
  departmentName: "",
  azureProjectName: "",
  // monthCycle: "",
  // year: new Date(),
  monthCycle: { value: "Oct-Dec", label: "Oct-Dec" },
  year: new Date(2023, 0, 1),
  plann: "",
  plannedDate: "",
  version: "",
  lastUpdate: "",
  lastVersionUpdate: "",
  comment: "",
};

const FormProjectPlan = (props) => {
  const [showValidation, setShowValidation] = useState({
    departmentNameError: null,
    azureProjectNameError: null,
    // monthCycleError: null,
    plannError: null,
    lastVersionUpdateError: null,
    commentError: null,
  });
  const [projectData, setProjectData] = useState(initialProjectData);
  const [masterData, setMasterData] = useState({
    departments: [],
  });
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    const getDepartments = async () => {
      try {
        const allData = await axios.all([
          callAPI("GET", apiEndPoints.getDeptName),
        ]);
        if (allData && allData.length > 0) {
          const departments = allData[0].data.data;
          departments.forEach((item) => {
            item.value = item.departmentId;
            item.label = item.departmentName;
            delete item.departmentId;
            delete item.departmentName;
          });
          setMasterData({
            ...{ departments },
          });
        }
      } catch (error) {}
    };
    getDepartments();
  }, []);

  const handleProjectData = (val, key) => {
    setProjectData((previousData) => {
      return {
        ...previousData,
        [key]: val,
      };
    });
    setShowValidation((previousData) => {
      return {
        ...previousData,
        [`${key}Error`]: val ? false : true,
      };
    });
  };

  useEffect(() => {
    props.fetchProjectPlan();
  }, []);

  useEffect(() => {
    const getProjects = async () => {
      let projectList = [];
      if (projectData.departmentName) {
        const departmentName = projectData.departmentName.label;
        try {
          const resp = await callAPI(
            "GET",
            apiEndPoints.getProjName + "?departmentName=" + departmentName
          );
          projectList = resp.data.data;
          projectList.forEach((item) => {
            item.value = item.azureProjectId;
            item.label = item.azureProjectName;
            delete item.azureProjectId;
            delete item.azureProjectName;
            delete item.department;
          });
        } catch (err) {
          console.log("Error in fetching Project Names: ", err);
        }
      }
      setProjectList(projectList);
    };
    getProjects();
  }, [projectData.departmentName]);

  const clearFormFields = () => {
    setProjectData(initialProjectData);
    setShowValidation(false);
  };
  const clearFormFieldsOnAdd = () => {
    setProjectData({
      departmentName: projectData.departmentName,
      azureProjectName: "",
      monthCycle: projectData.monthCycle,
      year: new Date(2023, 0, 1),
      plann: "",
      plannedDate: "",
      version: "",
      lastUpdate: "",
      lastVersionUpdate: "",
      comment: "",
    });

    setShowValidation((prev) => {
      return {
        ...prev,
        azureProjectNameError: null,
        plannError: null,
        lastVersionUpdateError: null,
        commentError: null,
      };
    });
  };

  const validationHandler = () => {
    const data = Object.values(showValidation).every((item) => item === false);
    const data1 = { ...projectData };
    const data2 = { ...showValidation };
    for (const key in data1) {
      if (
        key !== "lastUpdate" &&
        key !== "plannedDate" &&
        key !== "version" &&
        data1[key] === ""
      ) {
        data2[`${key}Error`] = true;
      }
    }
    setShowValidation(data2);
    return data;
  };

  const handleSubmit = async () => {
    if (validationHandler() === false) {
      return false;
    }
    try {
      const employeeName = sessionStorage.getItem("employeeName");
      const response = await axios.post(
        apiEndPoints.addRecordInProjectPlanReport,
        {
          departmentId: projectData.departmentName.value,
          azureProjectId: projectData.azureProjectName.value,
          monthCycle: projectData.monthCycle.value,
          year: projectData.year.getFullYear(),
          plann: projectData.plann.value,
          plannedDate: projectData.plannedDate,
          version: projectData.version,
          lastUpdate: projectData.lastUpdate,
          lastVersionUpdate: projectData.lastVersionUpdate.value,
          comment: projectData.comment,
          username: employeeName,
        }
      );
      // clearFormFields();
      clearFormFieldsOnAdd();
      // document.getElementById("exampleModalLong2").click();
      props.fetchProjectPlan();
      toast.success("Form submitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage = error.response.data.message;
        alert(`${errorMessage}`);
      } else {
        console.error("Error submission", error);
      }
    }
  };

  return (
    <form
      className="modal fade bd-example-modal-lg"
      id="exampleModalLong2"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Project Plan
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                clearFormFields();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <SelectList
              ErrorStyle={showValidation.departmentNameError ? "invalid" : ""}
              label="Department Name"
              id="deptName"
              placeholder="Department Name"
              value={projectData.departmentName}
              onChange={(value, e) => {
                handleProjectData(value, "departmentName");
              }}
              options={masterData.departments}
              isSearchable={true}
            />
            <SelectList
              ErrorStyle={showValidation.azureProjectNameError ? "invalid" : ""}
              label="Project Name"
              id="Project"
              placeholder="Project Name"
              value={projectData.azureProjectName}
              onChange={(value, e) => {
                handleProjectData(value, "azureProjectName");
              }}
              options={projectList}
              isSearchable={true}
            />
            <DatePickerField
              id="projYear"
              label="Year"
              showYearPicker
              dateFormat="yyyy"
              placeholderText="Select Year"
              selected={projectData.year}
              onChange={(date) => {
                handleProjectData(date, "year");
              }}
            />
          </div>
          <div className="modal-body">
            <SelectList
              ErrorStyle={showValidation.monthCycleError ? "invalid" : ""}
              label="Quarter"
              id="Quarter"
              placeholder="Quarter"
              options={["Jan-Mar", "Apr-Jun", "July-Sep", "Oct-Dec"]}
              defaultValue={{ value: "Oct-Dec", label: "Oct-Dec" }}
              value={projectData.monthCycle}
              onChange={(value) => handleProjectData(value, "monthCycle")}
            />
            <SelectList
              ErrorStyle={showValidation.plannError ? "invalid" : ""}
              label="Project Plan"
              id="plann"
              placeholder="Project Plan"
              options={["Yes", "No", "N/A"]}
              value={projectData.plann}
              onChange={(value, e) => handleProjectData(value, "plann")}
            />
            <DatePickerField
              id="plannedDate"
              label="Planned Date"
              dateFormat="yyyy-MM-dd"
              placeholderText="Select planned Date"
              selected={projectData.plannedDate}
              onChange={(date) => {
                handleProjectData(date, "plannedDate");
              }}
            />
          </div>
          <div className="modal-body">
            <TextInputField
              label="Version"
              id="version"
              value={projectData.version}
              onChange={(e) => handleProjectData(e.target.value, "version")}
            />
            <DatePickerField
              type="date"
              id="lastUpdate"
              label="Last Update"
              dateFormat="yyyy-MM-dd"
              placeholderText="Select last Update Date"
              selected={projectData.lastUpdate}
              onChange={(date) => {
                handleProjectData(date, "lastUpdate");
              }}
            />
            <SelectList
              ErrorStyle={
                showValidation.lastVersionUpdateError ? "invalid" : ""
              }
              label="Last Version Update"
              id="lastVersionUpdate"
              placeholder="Last Version Update"
              options={["Yes", "No", "N/A"]}
              value={projectData.lastVersionUpdate}
              onChange={(value, e) =>
                handleProjectData(value, "lastVersionUpdate")
              }
            />
          </div>
          <div className="modal-body">
            <TextArea
              ErrorStyle={showValidation.commentError ? "invalid" : ""}
              label="Comment"
              id="comment"
              rows={1}
              cols={20}
              value={projectData.comment}
              onChange={(e) => handleProjectData(e.target.value, "comment")}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-success btn-Add"
            >
              Add
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-dismiss="modal"
              onClick={() => {
                clearFormFields();
                setShowValidation(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FormProjectPlan;
